import { Component, OnInit, Optional, Inject, Input } from "@angular/core";
import { FromFieldControl } from "../form-field-control";
import { FormGroupDirective } from "@angular/forms";
import moment from "moment";

import {
	MatDatepicker
} from "@angular/material/datepicker";
import {
	MAT_DATE_LOCALE,
	DateAdapter,
	MAT_DATE_FORMATS

} from "@angular/material/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";

export const MONTH_YEAR_FORMAT = {
	parse: {
		dateInput: "MM/YYYY"
	},
	display: {
		dateInput: "MM/YYYY",
		monthYearLabel: "MMM YYYY",
		dateA11yLabel: "LL",
		monthYearA11yLabel: "MMMM YYYY"
	}
};

@Component({
    selector: "tc-expiry-month-form-field",
    templateUrl: "./expiry-month-form-field.component.html",
    styleUrls: ["./expiry-month-form-field.component.scss"],
    providers: [
        // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
        // `MatMomentDateModule` in your applications root module. We provide it at the component level
        // here, due to limitations of our example generation script.
        { provide: MAT_DATE_LOCALE, useValue: "en-AU" },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE]
        },
        { provide: MAT_DATE_FORMATS, useValue: MONTH_YEAR_FORMAT }
    ],
    standalone: false
})
export class ExpiryMonthFormFieldComponent extends FromFieldControl
	implements OnInit {
	@Input() filterFn: (d: moment.Moment) => boolean;

	constructor(
		@Optional()
		@Inject(FormGroupDirective)
		__formGroupDirective: FormGroupDirective
	) {
		super(__formGroupDirective);
	}

	private __val = moment();

	ngOnInit() {
		if (this._control.value) {
			this.__val = moment(this._control.value, "MM/YYYY");
			// } else {
			// 	this._control.setValue(this.__val);
		}
	}

	_chosenYearHandler(normalizedYear: moment.Moment) {
		console.log("control : ", this._control);
		const ctrlValue = this._control.value || this.__val;
		console.log("control value : ", ctrlValue);
		ctrlValue.year(normalizedYear.year());
		if (this._control.value) {
			this._control.setValue(ctrlValue);
		} else {
			this.__val = ctrlValue;
		}
		console.log("control value : ", this._control.value);
	}

	_chosenMonthHandler(
		normlizedMonth: moment.Moment,
		datepicker: MatDatepicker<moment.Moment>
	) {
		const ctrlValue = this._control.value || this.__val;
		ctrlValue.month(normlizedMonth.month());
		if (this._control.value) {
			this._control.setValue(ctrlValue);
		} else {
			this.__val = ctrlValue;
			this._control.setValue(this.__val);
		}
		datepicker.close();
	}
}
